{
  "messages": {
    "networkError": "네트워크 오류가 발생했습니다. 문제가 계속되면 문의해 주세요.",
    "appointmentUpdatedValidationFailed": "예약이 업데이트되었지만 외부 검증에 실패했습니다.",
    "appointmentCreatedValidationFailed": "예약이 생성되었지만 외부 검증에 실패했습니다.",
    "validationErrorDetail": "<br /> 검증 오류: {error}"
  },
  "titles": {
    "warehouseRuleFailed": "창고 규칙 위반",
    "validationServerError": "검증 서버 오류",
    "appointmentUpdatedWithValidationError": "검증 오류와 함께 예약이 업데이트됨",
    "appointmentCreatedWithValidationError": "검증 오류와 함께 예약이 생성됨"
  }
}
